/* src/app/ooops/ooops.component.scss */
/*# sourceMappingURL=ooops.component.css.map */
